// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1vtAR","content":"LoadingAlert_content__Q5jXE"};